import { useState } from "react";
import { useParams } from "react-router-dom";
// Constants - Functions
import { pathHomePage } from "../../../../../config/constants";
import { renderToolTip } from "../../../../../config/functions";
// Components
import {
  MainDiv,
  Div,
  Text,
  VideoButton,
  ProtocolImgDiv,
  ProtocolImg,
  InfoVideoImg,
  ProtocolName,
  DetailsDiv,
  DetailsLink,
  DetailsImg,
} from "./styles";
import ProtocolVideoPopup from "../../../../protocolVideoPopup";
// Assets
import IcoVideo from "../../../../../assets/icons/ico_video.svg";
import IcoInfo from "../../../../../assets/icons/ico_info_blue.svg";
import IcoReports from "../../../../../assets/icons/ico_reports.svg";

const ProtocolData = ({
  protocolId,
  protocolImg,
  protocolName,
  protocolVideo,
  protocolDescription,
  averageTime,
  accumulatedTime,
  sessionsNumber,
}) => {
  const [isProtocolVideoShowed, setIsProtocolVideoShowed] = useState(false);
  const { clinicianToken, patientId } = useParams();

  const renderProtocolInfo = () => {
    return (
      <>
        <VideoButton onClick={() => setIsProtocolVideoShowed(true)} disabled={!protocolVideo}>
          <ProtocolImgDiv>
            <ProtocolImg src={protocolImg} alt="protocol-img" />
          </ProtocolImgDiv>
          <InfoVideoImg
            src={protocolVideo ? IcoVideo : IcoInfo}
            alt="ico-tooltip"
            data-for="protocolDescription"
            data-tip={protocolDescription}
          />
          {renderToolTip("protocolDescription")}
          <ProtocolName>{protocolName}</ProtocolName>
        </VideoButton>
        {isProtocolVideoShowed && <ProtocolVideoPopup setIsProtocolVideoShowed={setIsProtocolVideoShowed} protocolId={protocolId} />}
      </>
    );
  };

  const renderReportsButton = () => {
    return (
      <DetailsDiv width="110px">
        <DetailsLink to={`${pathHomePage}/reports/icu/${clinicianToken}/${patientId}/${protocolId}`} sessions={sessionsNumber}>
          <DetailsImg src={IcoReports} alt="ico-details" />
        </DetailsLink>
        <Text>{sessionsNumber > 0 ? sessionsNumber : "-"}</Text>
      </DetailsDiv>
    );
  };

  return (
    <MainDiv>
      <Div>
        {renderProtocolInfo()}
        <Text width="200px">{averageTime}</Text>
        <Text width="200px">{accumulatedTime}</Text>
        {renderReportsButton()}
      </Div>
    </MainDiv>
  );
};

export default ProtocolData;
